import React from 'react';
import {useState} from 'react';
import {useEffect} from 'react';
import {useRef} from 'react';
import {View, StyleSheet, Animated, Easing} from 'react-native';

export const IndeterMinateProgress = () => {
   const position = useRef(new Animated.ValueXY({x: 0, y: 0})).current;

   const startAnimation = () => {
      Animated.timing(position, {
         toValue: {x: 400, y: 0}, // The end position of the view
         duration: 4000, // Set the duration (in milliseconds) for the animation
         useNativeDriver: false,
      }).start(() => {
         position.setValue({x: -320, y: 0});
         startAnimation();
      });
   };
   useEffect(() => {
      startAnimation();
   }, []);
   return (
      <View style={styles.progressBar}>
         <Animated.View
            style={[
               position.getLayout(),
               {backgroundColor: '#002C71', width: 300, height: 8},
            ]}
         />
      </View>
   );
};

const styles = StyleSheet.create({
   progressBar: {
      height: 8,
      flexDirection: 'row',
      width: '100%',
      backgroundColor: '#003C94',
      borderColor: '#000',
   },
   absoluteFill: {
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
   },
});
